export const BASIC = {
  withTopAd: true,
};

export const NO_TOP_AD = Object.assign({}, BASIC, {
  withTopAd: false,
});

export default BASIC;
